import { useState, useEffect, useRef, Fragment } from "react";
import { API_URL, translate } from "../../utils";
import useFetch from "../../utils/useFetch";
import Alert from "../../components/Alert";
import Input from "../../components/Input";
import Textarea from "../../components/Textarea";
import Select from "../../components/Select";
import Checkboxes from "../../components/Checkboxes";
import Msg from "../../components/Msg";
import Submit from "../../components/Submit";

const Home = ({ lang }) => {
	const [url, setUrl] = useState(null);
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({});
	const [msg, setMsg] = useState({});

	const formElement = useRef(null);
	const { loading, data } = useFetch(url);

	useEffect(() => {
		const newUrl = new URL(`${API_URL}/contactInit`);
		const params = {
			lang,
		};
		newUrl.search = new URLSearchParams(params);
		setUrl(newUrl);
	}, []);

	useEffect(() => {
		if (data && data.resp === 1) {
			setNames({ ...data });
		}
	}, [data]);

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value }));
	};

	const handleCheckbox = (name, checked, value) => {
		if (checked) {
			setNames((names) => ({ ...names, [name]: value }));
		} else {
			setNames((names) => ({ ...names, [name]: "" }));
		}
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/contact`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			data.append(key, value);
		});
		data.append("lang", lang);

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setMsg({
					type: "success",
					text: json.text,
				});
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<Fragment>
			{loading ? (
				<Alert
					data={{
						type: "working",
						text: "",
					}}
				/>
			) : msg.type && msg.type === "success" ? (
				<Alert data={msg} />
			) : (
				<Fragment>
					<div className="match-play-container">
						<div>
							<div className="subhead">
								{translate(
									lang,
									`If you have general questions or comments regarding the World Wide Technology Championship, please submit them here.`,
									`Si tiene preguntas o comentarios en general acerca del World Wide Technology Championship, por favor envíelas desde aquí.`,
								)}
							</div>
							<div className="spacer-15"></div>
						</div>
					</div>

					<form
						ref={formElement}
						method="post"
						action="/"
						onSubmit={(e) => handleSubmit(e)}
					>
						<div className="form-group radios ">
							<Checkboxes
								type="v2"
								label={`${translate(
									lang,
									"I am interested in...",
									"Estoy interesado en...",
								)}`}
								reqd={true}
								data={[
									{
										name: "interested1",
										val: `${translate(
											lang,
											"Playing in the Pro-Am",
											"Jugar en el Pro-Am",
										)}`,
										label: "",
									},
									{
										name: "interested2",
										val: `${translate(lang, "Sponsorship", "Patrocinar")}`,
										label: "",
									},
									{
										name: "interested3",
										val: `${translate(lang, "Tickets", "Boletos")}`,
										label: "",
									},
									{
										name: "interested4",
										val: `${translate(
											lang,
											"Tournament Merchandise",
											"Mercancía del Torneo",
										)}`,
										label: "",
									},

									{
										name: "interested5",
										val: `${translate(
											lang,
											"Charity",
											"Obras de Beneficencia",
										)}`,
										label: "",
									},
									{
										name: "interested6",
										val: `${translate(
											lang,
											"Media Request",
											"Solicitud de Medios de Comunicación",
										)}`,
										label: "",
									},
									{
										name: "interested7",
										val: `${translate(lang, "Volunteering", "Ser Voluntario")}`,
										label: "",
									},
									{
										name: "interested8",
										val: `${translate(
											lang,
											"Offering Products or Services",
											"Ofrecer mis servicios",
										)}`,
										label: "",
									},
									{
										name: "interested9",
										val: `${translate(
											lang,
											"Los Cabos Junior Golf Series",
											"Los Cabos Junior Golf Series",
										)}`,
										label: "",
									},
									{
										name: "interested10",
										val: `${translate(lang, "Other", "Otro")}`,
										label: "",
									},
								]}
								values={[]}
								click={handleCheckbox}
							/>
						</div>

						<div className="spacer-15"></div>

						<h3>{translate(lang, "Information", "Información")}</h3>

						<div className="form-group">
							<Input
								name="fname"
								label={translate(lang, "First Name", "Nombre(s)")}
								reqd={true}
								value={names.fname || ""}
								update={handleUpdate}
								errors={errors}
								autocomplete="given-name"
							/>

							<Input
								name="lname"
								label={translate(lang, "Last Name", "Apellido")}
								reqd={true}
								value={names.lname || ""}
								update={handleUpdate}
								errors={errors}
								autocomplete="family-name"
							/>
						</div>

						<div className="form-group">
							<Input
								name="email"
								label={translate(lang, "Email", "Correo Electrónico")}
								reqd={true}
								value={names.email || ""}
								update={handleUpdate}
								errors={errors}
							/>

							<div className="two-inputs">
								<Select
									name="phoneCode"
									label={translate(lang, "Country Code", "Código del País")}
									reqd={false}
									value={names.phoneCode || ""}
									options={[
										{ id: "+1", name: "US / CA (+1)" },
										{ id: "+52", name: "MX (+52)" },
										{
											id: "other",
											name: `${translate(lang, "Other", "Otros")}`,
										},
									]}
									update={handleUpdate}
									errors={errors}
									autocomplete="tel-country-code"
								/>
								<Input
									name="phone"
									label={translate(lang, "Phone", "Teléfono")}
									reqd={false}
									value={names.phone || ""}
									update={handleUpdate}
									errors={errors}
									autocomplete="tel-national"
								/>
							</div>
						</div>

						<div className="form-group one">
							<Textarea
								name="comments"
								label={translate(
									lang,
									"Question / Comment",
									"Pregunta / Comentario",
								)}
								reqd={true}
								value={names.comments || ""}
								update={handleUpdate}
								errors={errors}
							/>
						</div>

						<div className="form-group">
							<Select
								name="newsletter"
								label={translate(
									lang,
									"I would like to receive the monthly electronic newsletter",
									"Deseo recibir el boletín de noticias",
								)}
								reqd={false}
								value={names.newsletter || ""}
								options={[
									{ id: "", name: "--" },
									{
										id: "en",
										name: `${translate(lang, "English", "English")}`,
									},
									{
										id: "es",
										name: `${translate(lang, "Español", "Español")}`,
									},
								]}
								update={handleUpdate}
								errors={errors}
								autocomplete="off"
							/>

							<div className="empty" />
						</div>

						<div className="msg-submit" style={{ marginTop: "0" }}>
							{msg.type && <Msg data={msg} />}

							<div
								className={
									msg.type === "working" || msg.type === "success"
										? "hidden"
										: "submit-container"
								}
							>
								<Submit
									path=""
									left=""
									icon="fa fa-envelope-o"
									submit={translate(lang, "Submit Message", "Enviar")}
								/>
							</div>
						</div>
					</form>
				</Fragment>
			)}
		</Fragment>
	);
};

export default Home;
